(function () {
  'use strict';

  if (window.FellinoraAiCompanionLoaded) {
    return;
  }

  window.FellinoraAiCompanionLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSection(section) {
    var items = section.querySelectorAll('[data-fac-reveal]');

    items.forEach(function (item, index) {
      item.style.setProperty('--fac-delay', Math.min(index * 120, 360) + 'ms');
    });

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('fac-is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('fac-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -10% 0px'
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function init() {
    document.querySelectorAll('[data-fac-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-fac-section]');

    if (section) {
      initSection(section);
    }
  });
})();
